import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as CommentActions from './comment.actions';
import { CommentService } from '@/core/services/comment.service';

@Injectable()
export class CommentEffects {
  private actions$ = inject(Actions);
  private commentService = inject(CommentService);

  loadComments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommentActions.loadComments),
      switchMap(({ parentType, parentId }) =>
        this.commentService.getComments(parentType, parentId).pipe(
          map((comments) => CommentActions.loadCommentsSuccess({ comments })),
          catchError((error) => of(CommentActions.loadCommentsFailure({ error })))
        )
      )
    )
  );

  addComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommentActions.addComment),
      switchMap(({ parentType, parentId, commentData }) =>
        this.commentService.addComment(parentType, parentId, commentData).pipe(
          map((comment) => CommentActions.addCommentSuccess({ comment })),
          catchError((error) => of(CommentActions.addCommentFailure({ error })))
        )
      )
    )
  );

  updateComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommentActions.updateComment),
      switchMap(({ commentId, commentData }) =>
        this.commentService.updateComment(commentId, commentData).pipe(
          map((comment) => CommentActions.updateCommentSuccess({ comment })),
          catchError((error) => of(CommentActions.updateCommentFailure({ error })))
        )
      )
    )
  );

  deleteComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommentActions.deleteComment),
      switchMap(({ commentId }) =>
        this.commentService.deleteComment(commentId).pipe(
          map(() => CommentActions.deleteCommentSuccess({ commentId })),
          catchError((error) => of(CommentActions.deleteCommentFailure({ error })))
        )
      )
    )
  );
}
